import PropTypes from "prop-types"
import * as React from "react"
import styled from "@emotion/styled"
import { navigate } from "gatsby"
import Chevron from "components/Icons/Chevron"
import useMedia from "../../hooks/useMedia"
import HeaderNavSublist from "./HeaderNavSublist"
import HeaderNavSublistWrapper from "./HeaderNavSublistWrapper"
import HeaderNavItemBtn from "./HeaderNavItemBtn"
import HeaderNavItemWrapper from "./HeaderNavItemWrapper"
import HeaderFeaturedList from "./HeaderFeaturedNavList"
import HeaderCommonNavList from "./HeaderCommonNavList"
import HeaderSeparator from "./HeaderSeparator"
import HeaderAbsoluteButtons from "./HeaderAbsoluteButtons"

const Title = styled.p`
  margin: 16px 0;

  ${({ isScrolled, hasScroll, theme, isHeaderHovered }) => {
    if (!hasScroll) {
      return ""
    }

    if (isHeaderHovered) {
      return `color: ${theme.palette.gray["900"]};`
    }

    const isSticky = isScrolled
    return `
      color: ${isSticky ? theme.palette.gray["900"] : theme.palette.common.white};

      
    `
  }}
`

const HeaderNavItem = ({
  handleClose,
  link,
  subItems,
  title,
  hasAbsolutePosition,
  isScrolled,
  isHovered: isHeaderHovered,
  hasScroll,
}) => {
  const [active, setActive] = React.useState(false)
  const isXLScreen = useMedia(["(max-width: 1279px)"], [false], true)
  const [isHovered, setIsHovered] = React.useState(false)
  const [didHydrate, setDidHydrate] = React.useState(false)

  React.useEffect(() => {
    setDidHydrate(true)
  }, [])

  React.useEffect(() => {
    if (didHydrate && !isXLScreen) {
      setActive(false)
      handleClose(false)
    }
  }, [isXLScreen, didHydrate, handleClose])

  const handleClick = () => {
    if (!subItems) {
      handleClose(false)
      navigate(link)
    } else {
      setActive(!active)
    }
  }

  const handleMouseEnter = () => {
    if (hasAbsolutePosition && isXLScreen) setIsHovered(true)
  }

  const handleMouseLeave = () => {
    if (hasAbsolutePosition && isXLScreen) setIsHovered(false)
  }

  return (
    <HeaderNavItemWrapper
      active={active}
      didHydrate={didHydrate}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <HeaderNavItemBtn active={active} onClick={handleClick}>
        <Title isHeaderHovered={isHeaderHovered} isScrolled={isScrolled} hasScroll={hasScroll}>
          {title}
        </Title>
        {subItems && (
          <Chevron
            color={subItems && (!hasScroll || isScrolled || isHeaderHovered) ? "#1C1C1C " : "#FFF"}
          />
        )}
      </HeaderNavItemBtn>
      {subItems && (
        <HeaderNavSublistWrapper
          showIndicator={isXLScreen && subItems !== null}
          className="header-nav-sublist"
          hasAbsolutePosition={hasAbsolutePosition}
          active={active}
        >
          <HeaderNavSublist>
            {subItems.map((subItem, index) => (
              <React.Fragment key={subItem.title}>
                {index !== 0 && <HeaderSeparator />}
                {subItem.featured ? (
                  <HeaderFeaturedList {...subItem} />
                ) : (
                  <HeaderCommonNavList {...subItem} />
                )}
              </React.Fragment>
            ))}
          </HeaderNavSublist>
        </HeaderNavSublistWrapper>
      )}
      {subItems && hasAbsolutePosition && (
        <HeaderAbsoluteButtons isVisible={isHovered}>
          {subItems.map((subItem) => (
            <HeaderCommonNavList key={subItem.title} {...subItem} />
          ))}
        </HeaderAbsoluteButtons>
      )}
    </HeaderNavItemWrapper>
  )
}

HeaderNavItem.propTypes = {
  link: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  isScrollingUp: PropTypes.bool,
  isScrolled: PropTypes.bool,
  hasScroll: PropTypes.bool,
  hasAbsolutePosition: PropTypes.bool,
  subItems: PropTypes.arrayOf(
    PropTypes.shape({
      modelName: PropTypes.string,
      title: PropTypes.string,
      featured: PropTypes.bool,
      subItems: PropTypes.arrayOf(
        PropTypes.shape({
          featured: PropTypes.bool,
          icon: PropTypes.shape({
            file: PropTypes.shape({
              url: PropTypes.string,
            }),
            link: PropTypes.string,
            title: PropTypes.string,
            subtitle: PropTypes.string,
          }),
        }),
      ),
    }),
  ),
  handleClose: PropTypes.func.isRequired,
  isHovered: PropTypes.bool,
}

HeaderNavItem.defaultProps = {
  subItems: [],
  hasAbsolutePosition: false,
  isScrollingUp: false,
  isScrolled: false,
  hasScroll: false,
  isHovered: false,
}

export default HeaderNavItem
